import { DocumentTitle } from 'library/head';
import { AutodeskCameraDetailViewer } from 'modules/dashboard/features/autodesk-integration-viewer';
import useAutodeskCameraImages from 'modules/dashboard/features/autodesk-integration-viewer/hooks/useAutodeskCameraImages';
import useAutodeskIntegrationViewerData from 'modules/dashboard/features/autodesk-integration-viewer/hooks/useAutodeskIntegrationViewerData';
import PagePreloader from 'modules/shared/components/loaders/PagePreloader';
import {
    IllustrationView,
    NoImagesIllustration,
    SomethingWentWrongIllustration,
} from 'modules/shared/features/illustration';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const AutodeskIntegrationViewerPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('t');

    const autodeskIntegrationViewerData = useAutodeskIntegrationViewerData(token);

    const {
        isInitialLoading,
        isLoading: isImagesQueryLoading,
        images,
        selectedImage,
        setSelectedImage,
        selectedDate,
        setSelectedDate,
        startDate,
        endDate,
        refetch,
    } = useAutodeskCameraImages(token);

    useEffect(() => {
        if (!autodeskIntegrationViewerData.integration) return;

        const intervalInMilliseconds = +autodeskIntegrationViewerData.integration.refreshInterval * 60 * 1000; // refreshInterval is in minutes

        setInterval(() => {
            console.log('Refetching...');
            // Reset date to refetch the latest images
            setSelectedDate(null);

            // Refetch images query
            refetch();
        }, intervalInMilliseconds);
    }, [autodeskIntegrationViewerData.integration, refetch, setSelectedDate]);

    if (autodeskIntegrationViewerData.isLoading || isInitialLoading) return <PagePreloader />;

    if (autodeskIntegrationViewerData.error)
        return (
            <IllustrationView
                className="justify-center h-screen"
                illustration={<SomethingWentWrongIllustration />}
                title="Link Expired"
                message="This link has expired."
            />
        );

    const { camera, project, integration } = autodeskIntegrationViewerData;

    return (
        <>
            <DocumentTitle>
                {camera.name} - {project.name}
            </DocumentTitle>

            <>
                {camera.hasImages ? (
                    <AutodeskCameraDetailViewer
                        camera={camera}
                        project={project}
                        integration={integration}
                        images={images}
                        selectedImage={selectedImage}
                        onSelectedImageChange={setSelectedImage}
                        selectedDate={selectedDate}
                        onSelectedDateChange={setSelectedDate}
                        startDate={startDate}
                        endDate={endDate}
                        isLoading={isImagesQueryLoading}
                    />
                ) : (
                    <IllustrationView
                        className="justify-center h-screen"
                        illustration={<NoImagesIllustration />}
                        title="No Images yet"
                        message="No images for this camera found."
                    />
                )}
            </>
        </>
    );
};

export default AutodeskIntegrationViewerPage;
